import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P26-E1',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page26/E1/Key/answerKey.png',
    titleQuestion: [{ num: '1', title: 'Circle the odd-one-out. Write.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: ['seventeen', 'drawers', 'noodles', 'twenty'],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { margin: '5px', border: 'solid 2px', borderColor: 'black', borderRadius: 10, padding: '0 5px', backgroundColor: 'white' },
        selectWordStyle: { borderColor: '#00a8ec' },
        limitSelect: 1,
        listWords: [
          'bed cabinet shelf seventeen', //0
          'forty drawers eighty one_hundred', //1
          'noodles thirteen twenty fifteen', //2
          'rug twenty pillow blanket', //3
        ],
        answers: ['0-6', '1-2', '2-0', '3-2'],
        initialValue: [],
      },
      Layout: `
        <div style='background-color: #F0F9E8; padding: 20px;'>
          <div style='margin: 5px;'><b>1</b>
            <span style='margin: 0 13px; border: 2px solid rgb(0, 168, 236); border-radius: 10px; padding: 5px 5px; background-color: white;'>table</span>
            <span style='margin: 0 13px; border: 2px solid black; border-radius: 10px; padding: 5px 5px; background-color: white;'>milkshake</span>
            <span style='margin: 0 13px; border: 2px solid black; border-radius: 10px; padding: 5px 5px; background-color: white;'>noodles</span>
            <span style='margin: 0 13px; border: 2px solid black; border-radius: 10px; padding: 5px 5px; background-color: white;'>pizza</span>
            <span><u style='text-decoration-color: black;color:rgb(82,197,235)'>&ensp;table&emsp;</u></span>
          </div>
          <div><span style='display:flex;justify-content: space-between; width: 700px;align-items: center;'><b>2</b> <input id='0' type='Circle' /> <input id='0' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 700px;align-items: center;'><b>3</b> <input id='1' type='Circle' /> <input id='1' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 700px;align-items: center;'><b>4</b> <input id='2' type='Circle' /> <input id='2' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 700px;align-items: center;'><b>5</b> <input id='3' type='Circle' /> <input id='3' /></span> </div>
        </div>
      `,
    },
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P26-E2',
    audio: '',
    video: '',
    component: D1,
    // recorder: true,
    textAlign: 'center',
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page26/E2/Key/answerKey.png',
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/3.jpg', input: true, answer: "f" },
        { url: 'img/FriendsPlus/Page26/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page26/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page26/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/7.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page26/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page26/E2/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page26/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/11.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page26/E2/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page26/E2/13.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page26/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/15.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page26/E2/16.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page26/E2/17.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page26/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/19.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page26/E2/20.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page26/E2/21.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P26-E3',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    titleImage: '',
    questionImage: [[{ url: 'img/FriendsPlus/Page26/E3/1.jpg' }]],
  },
}

export default json;